export default function DownloadCta() {
  return (
    <section id="download" className="mx-auto max-w-[1400px] scroll-mt-24 px-4 py-12 md:px-6 md:py-16">
      <div className="relative overflow-hidden rounded-lg bg-primary-600 px-6 py-10 md:px-12 md:py-14">
        <i className="ri-eye-2-line pointer-events-none absolute -right-8 -top-8 text-[10rem] text-primary-500/60" />
        <div className="relative flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-1 rounded bg-black/20 px-2 py-1 text-xs font-bold text-white">
              <i className="ri-megaphone-fill" /> 站内下载通道
            </span>
            <h2 className="font-heading mt-4 text-2xl font-black leading-tight text-white md:text-4xl">
              下载「网曝网」App，深扒档案随身查
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-primary-100 md:text-base">
              人物档案、黑料合集、塌房时间线与实时速报全部同步更新，支持收藏、离线阅读与热度提醒。
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row">
            <a href="#" className="inline-flex h-14 items-center gap-3 whitespace-nowrap rounded-md bg-white px-6 text-left text-foreground-950 transition-transform hover:scale-[1.02]">
              <i className="ri-apple-fill text-2xl" />
              <span>
                <span className="block text-[10px] text-foreground-500">Download on</span>
                <span className="block text-base font-bold">App Store</span>
              </span>
            </a>
            <a href="#" className="inline-flex h-14 items-center gap-3 whitespace-nowrap rounded-md border border-white/40 bg-black/10 px-6 text-left text-white backdrop-blur transition-transform hover:scale-[1.02]">
              <i className="ri-android-fill text-2xl" />
              <span>
                <span className="block text-[10px] text-white/70">Get it on</span>
                <span className="block text-base font-bold">Google Play</span>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}